import styled from 'styled-components'

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
